module.exports = __webpack_public_path__ + "img/calendar2-minus.44073a13.svg";